module.exports = __webpack_public_path__ + "img/slide8.70741f03.jpg";